export default __webpack_public_path__ + "static/media/no-img.850cfe89.svg";